export default __webpack_public_path__ + "static/media/team35.b7e88812.JPG";